import { useEffect, useState } from "react";
import MobileDetect from "mobile-detect";

// Detect if a mobile browser is being used
const detectMobileSession = () => {
  return !!new MobileDetect(window.navigator.userAgent).mobile();
};

/**
 * Detect if the app is running in a mobile browser.
 * Auto-updates when viewport changes (useful for browser mobile emulator)
 */
export const useIsMobile = () => {
  const [isMobileSession, setIsMobileSession] = useState(detectMobileSession());

  useEffect(() => {
    const updateIsMobile = () => {
      // userAgent sometimes updates a little late after resize
      // eslint-disable-next-line no-undef
      setTimeout(() => {
        setIsMobileSession(detectMobileSession());
      });
    };

    window.addEventListener("resize", updateIsMobile);
    return () => window.removeEventListener("resize", updateIsMobile);
  }, []);

  return isMobileSession;
};